var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('a-row',[_c('a-col',[_c('p',{staticClass:"copyright"},[_vm._v(" © 2024 All rights reserved by "),_c('b',{staticStyle:{"color":"rgb(24, 143, 253)"}},[_vm._v("Pairplex")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }